import { render, staticRenderFns } from "./TheEditRule.vue?vue&type=template&id=5e66a785&"
import script from "./TheEditRule.vue?vue&type=script&lang=js&"
export * from "./TheEditRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports